import { RESET, CLEAR, LOGOUT, USER_NOT_EXIST } from "store/actionTypes/login";

// constants
const initialState = {
  expired: false,
  userNotExistError: false,
};

// reducer
const loginDetails = (state = initialState, action) => {
  switch (action.type) {
    case RESET:
      return { ...state, ...initialState };
    case CLEAR:
      return { ...state, ...initialState };
    case USER_NOT_EXIST:
      return { ...state, userNotExistError: true, expired: false };
    case LOGOUT:
      return { ...state, expired: true};
    default:
      return state;
  }
};

export default loginDetails;
